import { render } from "./FooterBar.vue?vue&type=template&id=6b4fe60c"
import script from "./FooterBar.vue?vue&type=script&lang=ts"
export * from "./FooterBar.vue?vue&type=script&lang=ts"
script.render = render

export default script